exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._24DdwsDAHoZxZTTxx3GJzj._1LtN3rcMb40hJy1OuN_96N,._24DdwsDAHoZxZTTxx3GJzj._3by27OZ041X6iPHpKdo1Xn{font-size:12px}._24DdwsDAHoZxZTTxx3GJzj.HgLsnGcH6DxuHKqQ7E95K,._24DdwsDAHoZxZTTxx3GJzj._3by27OZ041X6iPHpKdo1Xn._2G7_RFtEUJ5xf0p_jZVoP6{font-size:14px}.NMZHiLBdv0yoaWSrrFweC._1LtN3rcMb40hJy1OuN_96N,.NMZHiLBdv0yoaWSrrFweC._3by27OZ041X6iPHpKdo1Xn{font-size:11px}.NMZHiLBdv0yoaWSrrFweC.HgLsnGcH6DxuHKqQ7E95K{font-size:12px}", ""]);
// Exports
exports.locals = {
	"messageListMajorTextNext": "_24DdwsDAHoZxZTTxx3GJzj",
	"compact": "_1LtN3rcMb40hJy1OuN_96N",
	"medium": "_3by27OZ041X6iPHpKdo1Xn",
	"full": "HgLsnGcH6DxuHKqQ7E95K",
	"firstLineText": "_2G7_RFtEUJ5xf0p_jZVoP6",
	"messageListMinorTextNext": "NMZHiLBdv0yoaWSrrFweC"
};